import React, { Component } from "react"
import Layout from "../components/layout"
import SEO from "../components/seo"

import { Group, Col, Section, CtaButton } from "../components/common"

import { faqs } from "../data"
import map from "../images/map.jpg"

class ContactPage extends Component {
  renderFAQ(item) {
    return (
      <div className="faqItem">
        <h4>{item.question}</h4>
        <p>{item.answer}</p>
        <hr />
      </div>
    )
  }

  renderFAQs() {
    return faqs.map(item => {
      return this.renderFAQ(item)
    })
  }

  render() {
    return (
      <>
        <Layout>
          <SEO title="Home" keywords={[]} />
          <Section dark={true} hasDivider={false}>
            <div style={{ height: 100 }} />
            <Group>
              <Col size="whole">
                <div className="headingAccent" />
                <div style={{ height: 32 }} />
                <h3 className="headerBigText">Get in Touch</h3>
                <p>Feel free to contact us with any inquiries.</p>
              </Col>
            </Group>
            <div style={{ height: 80 }} />
          </Section>

          <Section>
            <Group>
              <Col size="third">
                <div className="headingAccent" />
                <h3>Contact Information</h3>
              </Col>
              <Col size="third">
                <p style={{ fontSize: 18, lineHeight: 1.2 }}>
                  Email:{" "}
                  <a href="mailto:info@thesfactor.co">info@thesfactor.co</a>
                  <br />
                  <br />
                  Phone: +1.647.930.9075
                  <br />
                  <br />
                  Toll Free: +1.877.276.4822
                  <br />
                  <br />
                </p>
              </Col>
              <Col size="third">
                <img src={map} style={{ width: "100%" }} />
                <p style={{ fontSize: 18, lineHeight: 1.2 }}>
                  401 Bay Street Suite 2702
                  <br />
                  Toronto, Ontario
                  <br />
                  M5H 2Y4
                  <br />
                </p>
              </Col>
            </Group>
          </Section>
          <Section hasDivider={false}>
            {/* <Group>
              <Col size="third">
                <div className="headingAccent" />
                <h3>FAQs</h3>
              </Col>
              <Col size="two-thirds">
                <div style={{ height: 40 }} />
                {this.renderFAQs()}
              </Col>
            </Group> */}
          </Section>
        </Layout>
      </>
    )
  }
}

export default ContactPage
